module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1TS4M"))).then(() => parcelRequire('cvs7o'));